<section class="cz-notifications-component has-scrolling-list">
  <div class="notifications-list">
      <mat-toolbar color="primary" class="list-title-bar">
        <mat-toolbar-row matSort (matSortChange)="changeSort($event)">
          <div class="row header-container middle-xs">
            <div class="col-xs-1" *ngIf="showActions">
              <mat-checkbox #selectAllCheckbox (change)="checkUncheckAll($event)"></mat-checkbox>
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="changeCheckedReadState(true)">
                  <span [innerHTML]="'$notification_mark_as_read' | translate"></span>
                </button>
                <button mat-menu-item (click)="changeCheckedReadState(false)">
                  <span [innerHTML]="'$notification_mark_as_unread' | translate"></span>
                </button>
              </mat-menu>
            </div>
            <div class="col-xs-2">
              <span class="label" mat-sort-header="title"><span [innerHTML]="'$common_subject' | translate"></span></span>
            </div>
            <div class="col-xs-1">
              <span class="label ur" mat-sort-header="read"><span [innerHTML]="'$notification_read' | translate"></span></span>
            </div>
            <div class="col-xs-6">
              <span class="label dl" [innerHTML]="'$common_content' | translate"></span>
            </div>
            <div class="col-xs-2">
              <span class="label rs" mat-sort-header="notificationDate"><span [innerHTML]="'$common_date' | translate"></span></span>
            </div>
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="list-items" [formGroup]="actionForm">
        <p *ngIf="!sortedData || sortedData.length < 1" class="no-notifications text-center" [innerHTML]="'$notification_no_notifications_exist' | translate"></p>
        <div class="item row middle-xs" *ngFor="let row of sortedData" [ngClass]="{'unread': !row.read}">
          <div class="col-xs-1" *ngIf="showActions">
            <mat-checkbox [formControlName]="row.id"></mat-checkbox>
          </div>
          <div class="col-xs-2 open-dialog link" (click)="openNotificationDialog(row.id)">
            <span class="truncate">{{row.title}}</span>
          </div>
          <div class="col-xs-1 read-icons open-dialog" (click)="openNotificationDialog(row.id)">
              <mat-icon *ngIf="row.read">drafts</mat-icon>
              <mat-icon *ngIf="!row.read">mail</mat-icon>
          </div>
          <div class="col-xs-6 open-dialog link" (click)="openNotificationDialog(row.id)">
            <span class="truncate">{{row.messageAsHtml | noHtmlTags}}</span>
          </div>
          <div class="col-xs-2 open-dialog" (click)="openNotificationDialog(row.id)">
            <span>{{row.notificationDate | date:'MM-dd-yyyy' }}</span>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="!allShown" class="load-more-container">
        <button mat-button (click)="loadMoreNotifications()" color="accent" [innerHTML]="'$btn_load_more' | translate"></button>
      </div> -->
    </div>
</section>
